// The portal serves the three retained areas on their pre-merge base paths so
// existing links, bookmarks, and IdentityServer redirect URIs keep working.
export const AREA_BASE_PATHS = {
    designer: '/feedback/designer',
    analytics: '/feedback/analytics',
    admin: '/integrate/admin'
} as const;

export type PortalArea = keyof typeof AREA_BASE_PATHS;

export const DEFAULT_ROUTE = `${AREA_BASE_PATHS.analytics}/surveyresponses`;

// Per-area absolute base URL, e.g. https://sandbox.recx.io/feedback/designer.
// Matches the REACT_APP_BASE_URL each legacy app supplied per environment;
// AuthContainer derives the OIDC redirect URIs from it (<base>/callback etc.).
export function areaBaseOriginUrl(area: PortalArea): string {
    return `${window.location.origin}${AREA_BASE_PATHS[area]}`;
}
